function switchSubscription(option) {
    // Remove 'active' class from all items
    const switcherItems = document.querySelectorAll('.mj-subscription-card__switcher-item');
    switcherItems.forEach(item => {
        item.classList.remove('active');
    });

    // Select all items that match the given option
    const selectedOptions = document.querySelectorAll(`.mj-subscription-card__switcher-item[data-option="${option}"]`);

    // Add 'active' class to all matching items with a slight delay for a smooth transition
    setTimeout(() => {
        selectedOptions.forEach(selectedOption => {
            selectedOption.classList.add('active');
        });

        // Update the price text based on the selected option
        const priceElements = document.querySelectorAll('.mj-subscription-card__price.--premium');
        priceElements.forEach(priceElement => {
            const priceValue = option === 'monthly' ? '£15.99' : '£120';
            priceElement.innerHTML = `From <span>${priceValue}</span> /${option}`;
        });

        const priceElementsIr = document.querySelectorAll('.mj-subscription-card__price.--premium.--ireland');
        priceElementsIr.forEach(priceElement => {
            const priceValue = option === 'monthly' ? '€24.9' : '€249';
            priceElement.innerHTML = `From <span>${priceValue}</span> /${option}`;
        });


        // Toggle visibility of mj-subscription-card__gift-wrapper based on the selected option
        const giftWrapper = document.querySelector('.mj-subscription-card__gift-wrapper');
        
        if ( giftWrapper ) {
            if (option === 'monthly') {
                giftWrapper.style.opacity = 0;
                setTimeout(() => {
                    giftWrapper.style.display = 'none';
                }, 5); // Adjust the delay to match your transition duration
            } else {
                giftWrapper.style.display = 'flex';
                setTimeout(() => {
                    giftWrapper.style.opacity = 1;
                }, 5);
            }
        }

        const upgradeBtns = document.querySelectorAll('.mj-subscription-card__btn.upgrade');

        // Getting the current URL
        const currentUrl = window.location.href;

        // Creating a URL object
        const parsedUrl = new URL(currentUrl);

        // Extracting the main domain URL
        const mainDomainUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}/membership/`;

        upgradeBtns.forEach(upgradeBtn => {
            // Get the data-monthly-text and data-yearly-text attributes
            const monthlyText = upgradeBtn.getAttribute('data-monthly-text');
            const yearlyText = upgradeBtn.getAttribute('data-yearly-text');

            // Get the data-monthly-url and data-yearly-url attributes
            const monthlyUrl = upgradeBtn.getAttribute('data-monthly-url');
            const yearlyUrl = upgradeBtn.getAttribute('data-yearly-url');

            // Set the value and link based on the option
            if (option === 'monthly') {
                // upgradeBtn.value = monthlyText;
                upgradeBtn.textContent = monthlyText;
                upgradeBtn.href = monthlyUrl; // assuming the button is an anchor tag or has href property
            } else if (option === 'yearly') {
                upgradeBtn.textContent = yearlyText;
                upgradeBtn.href = yearlyUrl;
            }
        });

    }, 50);
}

function switchPartnership(option) {

    // Remove 'active' class from all items
    const switcherItems = document.querySelectorAll('.mj-subscription-card__switcher-item');
    switcherItems.forEach(item => {
        item.classList.remove('active');
    });

    // Select all items that match the given option
    const selectedOptions = document.querySelectorAll(`.mj-subscription-card__switcher-item[data-option="${option}"]`);

    // Add 'active' class to all matching items with a slight delay for a smooth transition
    setTimeout(() => {
        selectedOptions.forEach(selectedOption => {
            selectedOption.classList.add('active');
        });

        // Update the price text based on the selected option
        const priceElements = document.querySelectorAll('.mj-subscription-card__price-premium');
        priceElements.forEach(priceElement => {
            const priceValue = option === 'supplier' ? '£800' : '£1000';
            priceElement.innerHTML = `From <span>${priceValue}</span> /year + VAT for <span class="mj-subscription-card__price-type">${option}s</span>`;
        });

        const priceElementsIreland = document.querySelectorAll('.mj-subscription-card__price-premium.--ireland');
        
        if ( priceElementsIreland ) {
            priceElementsIreland.forEach(priceElement => {
                const priceValue = option === 'supplier' ? '€1,499' : '€1,999';
                priceElement.innerHTML = `From <span>${priceValue}</span> /year + VAT for <span class="mj-subscription-card__price-type">${option}s</span>`;
            });
        }

        const upgradeElement = document.querySelector('.mj-subscription-card__btn.request-upgrade');
        if (upgradeElement) {
            const upgradePlan = upgradeElement.getAttribute(`data-${option}-plan`);
            upgradeElement.setAttribute('data-type', upgradePlan);
        }

        updateRoleQueryParam('.mj-subscription-card__btn-free', option);
        updateRoleQueryParam('.mj-subscription-card__btn-premium', option);

    }, 50);
}

function updateRoleQueryParam(elementName, newRoleValue) {

    // Find the <a> element with the specified name
    var element = document.querySelector(elementName);

    if (!element) {
        console.error("Element not found.");
        return;
    }

    // Get the URL from the href attribute
    var url = element.getAttribute('href');

    // Parse the URL to extract the base URL and query parameters
    var urlParts = url.split('?');
    // var baseUrl = urlParts[0];
    var baseUrl = site_url_wpml();
    var queryParams = urlParts[1] ? new URLSearchParams(urlParts[1]) : new URLSearchParams();

    // Replace the value of 'role' with the new role value
    queryParams.set('role', newRoleValue);

    // Construct the new URL with the updated query parameters
    var newUrl = baseUrl + '?' + queryParams.toString();

    // Set the attribute with the new URL
    element.setAttribute('href', newUrl);
}

if (document.getElementById('expand-subscriptions')) {
    document.getElementById("expand-subscriptions").addEventListener("click", function (e) {
        e.preventDefault();
        var subscriptionsExpandable = document.getElementById("subscriptions-expandable");
        if (subscriptionsExpandable.classList.contains("--hide")) {
            subscriptionsExpandable.classList.remove("--hide");
        } else {
            subscriptionsExpandable.classList.add("--hide");
        }
    });
}